import { render, staticRenderFns } from "./CompanyCoordinates_Form.vue?vue&type=template&id=3b653da8&scoped=true"
import script from "./CompanyCoordinates_Form.vue?vue&type=script&lang=js"
export * from "./CompanyCoordinates_Form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b653da8",
  null
  
)

export default component.exports